import React, { useEffect, useState } from 'react';
import moment from 'moment';
import CancelIcon from '@material-ui/icons/Cancel';
import Audit from '../../../containers/Audit/Audit';

const NoteSection = ({
  styles,
  commentData,
  setShowAuditTrail,
  addNewComment,
  setTextVal,
  textVal,
  noteViewType,
  setShow,
  normalView
}) => {
  return (
    <div
      className={`${styles?.notes} ${!noteViewType &&
        'ml-5 shadow'} bg-white rounded h-screen ${
        normalView ? 'sticky top-0 ' : 'relative'
      }`}
    >
      <span className="flex px-3 py-4 items-center">
        <p className="font-roboto font-medium text-green-limedSpruce text-base md:hidden block">
          Add Notes
        </p>
        <p className="font-roboto font-medium text-green-limedSpruce text-base md:block hidden">
          Notes
        </p>
        <button
          onClick={() => setShowAuditTrail(true)}
          type="button"
          className="ml-auto font-open-sans px-4 py-1 rounded border border-yellow-fuelYellow text-yellow-fuelYellow bg-white text-roboto font-normal "
        >
          Audit trail
        </button>
        <CancelIcon
          onClick={() => setShow(false)}
          className=" md:hidden ml-2 "
        />
      </span>

      <hr className="text-grey-whatsAppBg mb-3 mt-1" />

      <div className="w-full px-4 mt-3 overflow-auto  h-screen ">
        <div
          className={`w-full ${!normalView &&
            'mb-35'} overflow-auto max-h-screen ${styles?.noteSectionComment}`}
        >
          {commentData &&
            commentData.length > 0 &&
            commentData.map((each, index) => {
              return (
                <div className="flex mb-3" key={index}>
                  <div className="table" style={{ width: '40px' }}>
                    <div
                      className="flex items-center justify-center  text-white w-8 h-8 bg-grey-300 rounded-full"
                      style={{
                        height: '33px',
                        width: '33px'
                      }}
                    >
                      {each?.name?.slice(0, 1)}
                    </div>
                  </div>
                  <div className="w-full font-open-sans text-black-700 ">
                    <p className="break-all">{each?.comment}</p>
                    <div className="flex justify-between text-black-1020 font-open-sans text-grey-baliHai text-xs">
                      <div>{each?.name}</div>

                      <div>
                        <span className="pr-2  font-open-sans text-grey-baliHai">
                          {moment(each?.createdAt).format('Do MMM YYYY')}
                        </span>
                        <span className=" font-open-sans text-grey-baliHai">
                          {moment(each?.createdAt).format('hh:mm A')}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
        <div
          className={`fixed bg-white w-full  ${styles?.noteSection} ${
            !noteViewType ? styles?.normalNotes : styles?.drawerNotes
          }`}
        >
          <textarea
            style={{ height: '90px' }}
            className="hover:shadow w-full  mr-3 p-2  border border-navy-400 rounded bg-green-greenWhite"
            cols="30"
            value={textVal}
            onChange={e => setTextVal(e.target.value)}
            placeholder="Add notes..."
          ></textarea>
          <div className="self-end ml-auto">
            <button
              className="border border-green-600 mx-auto flow-root w-10/12 font-normal font-roboto items-center text-sm ml-auto px-1 py-2 rounded  md:w-32 md:float-right"
              onClick={() => {
                if (textVal) {
                  addNewComment(textVal);
                  setTextVal('');
                }
              }}
              style={{
                backgroundColor: '#0A4549',
                color: 'white'
              }}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoteSection;
